import { useState } from "react";
import { PricingTable } from "@clerk/clerk-react";
import { BodyHeader } from "../components/Header";

export default function PricingPage() {
  const [billingCycle, setBillingCycle] = useState<"monthly" | "yearly">(
    "monthly",
  );

  return (
    <div className="w-screen h-screen flex flex-col overflow-hidden">
      <BodyHeader hasChanges={false} onRun={() => {}} onRefresh={() => {}} />
      <div className="flex flex-col grow w-full border-t border-border">
        <div className="max-w-screen-xl mx-auto px-8 py-12">
          {/* Header Section */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Choose the plan that fits your automation needs
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Run automations in your browser to log into accounts, scrape
              pages, or perform daily tasks—no setup required. Start free,
              upgrade when you're ready.
            </p>
          </div>

          {/* Pricing Table */}
          <PricingTable
            appearance={{
              elements: {
                card: "bg-gray-50 border-gray-200 !shadow-none",
                header: "bg-blue-50",
                title: "text-blue-900",
                price: "text-blue-700",
                featureList: "py-4",
                featureListItem: "text-gray-600",
                formButtonPrimary:
                  "bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded",
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}
